import * as React from "react";
import { SharedDocumentsComponent } from './SharedDocumentsComponent';

export const CommunicationWithEmployees = () => {
    return <SharedDocumentsComponent permissionId="74" path="Comunicação com Empregados" />
}
